export default __webpack_public_path__ + "static/data-vis-page-analytics-light-b9e2db7d639ee72d61312434ea165a33.png";